<template>
  <v-card v-if="interviewForAuditPeriod">
    <template v-if="interviewForAuditPeriod.json.length > 0">
      <v-card-title>
        {{ $t("auditor.interviewForm.generate.title") }}
      </v-card-title>

      <v-card-text>
        <v-btn color="primary" class="mr-4" @click="download">
          {{ $t("auditor.interviewForm.generate.cta") }}
        </v-btn>
      </v-card-text>

      <v-card-title>
        {{ $t("auditor.interviewForm.import.title") }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-file-input
            v-model="interviewFile"
            accept="text/csv"
            :label="$t('auditor.interviewForm.import.file.label')"
            :rules="[(v) => !!v || $t('validation.required')]"
          ></v-file-input>

          <v-btn color="primary" class="mr-4" @click="importInterview" :disabled="!valid" :loading="loading">
            {{ $t("auditor.interviewForm.import.cta") }}
          </v-btn>
        </v-form>
      </v-card-text>
    </template>

    <template v-else>
      <v-card-title>
        {{ $t("auditor.interviewForm.noOpenQuestions.title") }}
      </v-card-title>

      <v-card-text>
        <v-btn color="primary" class="mr-4" @click="skipInterview">
          {{ $t("auditor.interviewForm.noOpenQuestions.cta") }}
        </v-btn>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import InterviewForAuditPeriodQuery from "@/gql/queries/InterviewForAuditPeriodQuery.gql";
import ImportInterviewForAuditPeriodMutation from "@/gql/mutations/ImportInterviewForAuditPeriodMutation.gql";
import SkipInterviewForAuditPeriodMutation from "@/gql/mutations/SkipInterviewForAuditPeriodMutation.gql";
import download from "@/utils/download";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },

    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      interviewFile: null,
      valid: false,
      loading: false,
      interviewForAuditPeriod: null,
    };
  },

  apollo: {
    interviewForAuditPeriod: {
      query: InterviewForAuditPeriodQuery,
      variables() {
        return {
          id: this.auditPeriod.id,
        };
      },
    },
  },

  methods: {
    download() {
      const filename = `${this.user.company.address.name}_${this.auditPeriod.year}.csv`;

      download(filename, this.interviewForAuditPeriod.csv);
    },

    async importInterview() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: ImportInterviewForAuditPeriodMutation,
        variables: {
          id: this.auditPeriod.id,
          interview: this.interviewFile,
        },
      });

      this.loading = false;
    },

    async skipInterview() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: SkipInterviewForAuditPeriodMutation,
        variables: {
          id: this.auditPeriod.id,
        },
      });

      this.loading = false;
    },
  },
};
</script>
